import { NumColumns } from '@zocdoc-frontend-common/styles-grid';

// TODO: expose this in component SDK
export default function columnWidth(num) {
    return `${((num / NumColumns) * 100).toFixed(5)}%`;
}
